import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  InputBase,
  Avatar,
  Menu,
  MenuItem,
  Drawer,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import InventoryIcon from '@mui/icons-material/Inventory2';
import GroupIcon from '@mui/icons-material/Group';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Link } from 'react-router-dom';

import logoJhimbo from '../../images/logo-jhimbo.png';
import aguila from '../../images/aguila_puro.png';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: 50,
  backgroundColor: '#fff',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  width: '100%',
  maxWidth: 400,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.5, 2),
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#000',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#000',
  flex: 1,
  '&::placeholder': {
    color: '#000',
    opacity: 1,
  },
}));

export const NavbarEmpresaPrueba = ({
  isAuthenticated = true,
  userSession,
  profileBlobUrl,
  handleLogout,
}) => {
  // Estado para el menú del Avatar
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Estados y funciones para el Drawer en mobile
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  // Click en Avatar
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Cerrar menú del Avatar
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Contenido del Drawer para pantallas pequeñas
  const drawerContent = (
    <Box
      sx={{
        width: 250,
        py: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: '#0070FF',
        height: '100%',
      }}
    >
      <IconButton>
        <HomeIcon sx={{ color: 'white', fontSize: 28 }} />
      </IconButton>
      <IconButton>
        <InventoryIcon sx={{ color: 'white', fontSize: 28 }} />
      </IconButton>
      <IconButton>
        <GroupIcon sx={{ color: 'white', fontSize: 28 }} />
      </IconButton>
      <IconButton>
        <AttachMoneyIcon sx={{ color: 'white', fontSize: 28 }} />
      </IconButton>
    </Box>
  );

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#0070FF',
        height: 70,
        boxShadow: 3,
        px: 0, // <--- Sin padding horizontal en el navbar
      }}
    >
      <Toolbar
        sx={{
          height: '100%',
          minHeight: '0 !important',
          justifyContent: 'space-between',
          px: 0, // <--- Sin padding en el Toolbar
        }}
      >
        {/* Ícono "hamburger" (solo en mobile) */}
        <IconButton
          sx={{ display: { xs: 'block', md: 'none' }, ml: 1 }}
          onClick={handleDrawerToggle}
        >
          {drawerOpen ? (
            <MenuOpenIcon sx={{ fontSize: 30, color: 'white' }} />
          ) : (
            <MenuIcon sx={{ fontSize: 30, color: 'white' }} />
          )}
        </IconButton>

        {/* LOGO + AGUILA (con clipPath y sin padding left) */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
            height: '100%',
            width: '320px',
            clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)',
            position: 'relative',
            // Elimina paddings y offsets
            pl: 0,
            pr: 2,
            ml: { xs: 0, md: 2 },
          }}
        >
          <IconButton>
            <img
              src={aguila}
              alt="aguila"
              style={{
                width: 40,
                height: 40,
                background: '#eee',
                borderRadius: 8,
                padding: 5,
              }}
            />
          </IconButton>
          <img
            src={logoJhimbo}
            alt="Jhimbo Logo"
            style={{ height: 50, marginLeft: 8, marginRight: 5 }}
          />
        </Box>

        {/* ICONOS CENTRALES (se ocultan en XS, muestran en MD+) */}
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 4, // <--- Menos separación
          }}
        >
          <IconButton>
            <HomeIcon sx={{ color: 'white', fontSize: 30 }} />
          </IconButton>
          <IconButton>
            <InventoryIcon sx={{ color: 'white', fontSize: 30 }} />
          </IconButton>
          <IconButton>
            <GroupIcon sx={{ color: 'white', fontSize: 30 }} />
          </IconButton>
          <IconButton>
            <AttachMoneyIcon sx={{ color: 'white', fontSize: 30 }} />
          </IconButton>
        </Box>

        {/* BÚSQUEDA */}
        <Search sx={{ display: { xs: 'none', sm: 'flex' } }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase placeholder="Buscar en Jhimbo…" />
        </Search>

        {/* AVATAR CON MENÚ */}
        <Box sx={{ mr: 2 }}>
          <IconButton onClick={handleAvatarClick}>
            <Avatar
              src={isAuthenticated && profileBlobUrl ? profileBlobUrl : undefined}
              sx={{ bgcolor: 'gray', width: 40, height: 40, cursor: 'pointer' }}
              id="icon-perfil"
            />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                width: 200,
                backgroundColor: 'white',
                color: 'black',
                zIndex: 1300,
                mt: 1,
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            disableScrollLock={true}
          >
            <Link
              to={`/user/posts?authCode=${userSession?.authCode ?? 'demo'}`}
              style={{
                color: '#000',
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                width: '100%',
              }}
            >
              <MenuItem onClick={handleClose} sx={{ width: '100%' }}>
                <AccountCircleIcon sx={{ color: 'gray', marginRight: 1 }} />
                Perfil
              </MenuItem>
            </Link>

            <MenuItem onClick={handleClose}>
              <SettingsIcon sx={{ color: 'gray', marginRight: 1 }} />
              Configuración
            </MenuItem>

            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                handleClose();
                handleLogout?.();
              }}
            >
              <LogoutIcon sx={{ color: 'gray', marginRight: 1 }} />
              Salir
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      {/* DRAWER (MENU LATERAL) PARA MOBILE */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Mejora el rendimiento en móviles
        }}
      >
        {drawerContent}
      </Drawer>
    </AppBar>
  );
};
